import React, { useState } from "react";

/**
 * Remet les séparateurs entre les groupes de chiffres : "185039712345672"
 * → "1   85   03   97   123   456   72" pour [1, 2, 2, 2, 3, 3, 2] et "   ".
 * (Algorithme d'origine du composant, sorti tel quel pour servir aussi à
 * l'affichage d'une valeur initiale.)
 */
export function formaterGroupes(valeur, separation, separator) {
  var nirconcat = valeur.split(separator).join("");
  var newnir = "";
  var curr = 0;
  for (var key in separation) {
    var ns = separation[key] + curr;
    if (curr < nirconcat.length) {
      newnir += nirconcat.substring(curr, ns);
      var newnirsp = newnir.split(separator);
      if (
        newnirsp[newnirsp.length - 1].length == separation[key] && // eslint-disable-line eqeqeq
        newnirsp.length < separation.length
      ) {
        newnir += separator;
      }
    }

    curr = ns;
  }
  if (newnir.substr(newnir.length - separator.length) == separator) { // eslint-disable-line eqeqeq
    newnir = newnir.substring(0, newnir.length - separator.length);
  }
  return newnir;
}

const GroupedDigitControl = ({
  name,
  change,
  value,
  separation,
  separator,
  placeholder,
  type = "",
  className,
  autoFocus = false,
  // Identifiant historique conservé par défaut (Login, FormAccount) ; les
  // questions du formulaire passent le leur pour relier libellé et champ.
  id = "nir-login-inp",
  inputProps = {},
  // Classe de base de l'<input> : `form-control` partout, sauf dans le cadre
  // `.saisie` des écrans hors connexion qui porte lui-même la bordure.
  baseClassName = "form-control",
  // Chiffres à afficher dès le premier rendu (ex. NIR repris de l'écran
  // précédent) ; sans elle, le champ démarre vide comme avant.
  valeurInitiale = "",
}) => {
  const [formatedValue, setFormatedValue] = useState(() =>
    valeurInitiale ? formaterGroupes(String(valeurInitiale), separation, separator) : ""
  );

  function updateInput(e) {
    var nirconcat = e.target.value.split(separator).join("");
    var newnir = formaterGroupes(e.target.value, separation, separator);
    var longueur = separation.reduce((total, taille) => total + taille, 0);
    setFormatedValue(newnir);

    var upval = nirconcat.substring(0, longueur);
    if (type == "date") { // eslint-disable-line eqeqeq
      upval = newnir.split(separator)[2];
      upval += "-" + newnir.split(separator)[1];
      upval += "-" + newnir.split(separator)[0];
    }
    change({ target: { name: name, value: upval } });
  }
  return (
    <input
      id={id}
      type="text"
      inputMode="numeric"
      className={(baseClassName ? baseClassName + " " : "") + (className || "")}
      name={name}
      value={formatedValue}
      onChange={updateInput}
      placeholder={placeholder}
      autoFocus={autoFocus}
      {...inputProps}
    />
  );
};

export default GroupedDigitControl;
